import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';

import {
    CloseButton,
    Text,
    Flex,
    Spacer,
} from '@zillow/constellation';
import { Col } from '@zillow/zrs-comet';
import MultiSelect from '../Multiselect';

import { StyledPill } from './StyledComponents';

const propTypes = {
    title: PropTypes.string,
    value: PropTypes.array,
    handleClose: PropTypes.func,
    isFilterOpen: PropTypes.bool,
    handleChange: PropTypes.func,
};

const defaultProps = {
    title: '',
    value: [],
    handleClose: () => { },
    isFilterOpen: false,
    handleChange: () => { },
};

const MultiSelectFilterPill = ({
    title,
    value,
    handleClose,
    isFilterOpen,
    handleChange,
}) => {
    if (value.length < 1) return null; // Don't display filters for less than 1 value
    let activeLength = 0;
    value.forEach((v) => {
        if (v.isChecked) activeLength += 1;
    });
    if (!isFilterOpen && activeLength === 0) return null;

    const handleClearOptions = () => {
        const newValues = cloneDeep(value);
        newValues.forEach((v) => {
            v.isChecked = false;
        });
        handleClose(newValues);
    };

    if (isFilterOpen) {
        return (
            <Col sm={12} md={6} lg={4}>
                <Spacer marginY="xs">
                    <MultiSelect
                        label={title}
                        onChange={(i, newValue) => {
                            const newOptions = [
                                ...value.slice(0, i),
                                {
                                    ...value[i],
                                    isChecked: newValue,
                                },
                                ...value.slice(i + 1),
                            ];
                            handleChange(newOptions);
                        }}
                        options={value}
                    />
                </Spacer>
            </Col>
        );
    }
    return (
        <Col sm={6} md={4}>
            <StyledPill padding="sm" margin="xs">
                <Flex display="flex" justifyContent="space-between">
                    <div>
                        <Text as="div" fontType="bodySmallHeading">{title}</Text>
                        <Text as="div" fontType="bodySmall">{`(${activeLength}) selected`}</Text>
                    </div>
                    <div onClick={handleClearOptions} className="BillingFilterPill-close">
                        <CloseButton />
                    </div>
                </Flex>
            </StyledPill>
        </Col>
    );
};

MultiSelectFilterPill.propTypes = propTypes;
MultiSelectFilterPill.defaultProps = defaultProps;

export default MultiSelectFilterPill;
